import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="policy-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: January 10, 2025</p>

        <div className="policy-section">
          <h2>1. Information We Collect</h2>
          <p>We collect the following information to provide our services:</p>
          <ul>
            <li><strong>Account Details:</strong> Name, email, artist name, and contact information required for account setup and management.</li>
            <li><strong>Payment Information:</strong> Billing details processed securely for one-time plan purchases (Starter: $4.99, Pro: $14.99, Label: $49.99).</li>
            <li><strong>Content Submissions:</strong> Music files (WAV, FLAC, or high-quality MP3), artwork (3000×3000px minimum), and associated metadata.</li>
            <li><strong>Usage Data:</strong> How you interact with our platform, including distribution preferences and store selections.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>2. How We Use Your Information</h2>
          <p>Your information is used to:</p>
          <ul>
            <li>Process your one-time plan purchases and distribute music to selected platforms (Spotify, Apple Music, Tidal, etc.).</li>
            <li>Track and distribute royalties with our 15% revenue share model after platform fees.</li>
            <li>Review content against our guidelines (e.g., cover art standards, audio requirements).</li>
            <li>Provide customer support for account and distribution management.</li>
            <li>Process payouts once your balance reaches the $100 minimum threshold.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Data Sharing and Disclosure</h2>
          <p>We share your information with:</p>
          <ul>
            <li><strong>Music Platforms:</strong> Required metadata and content for distribution to your selected stores.</li>
            <li><strong>Payment Processors:</strong> For secure handling of one-time payments and royalty distributions.</li>
            <li><strong>Content Review Teams:</strong> To ensure compliance with our content guidelines and copyright requirements.</li>
            <li><strong>Legal Authorities:</strong> When required by law or to protect our rights and users.</li>
          </ul>
          <p>We do not sell your personal information to third parties.</p>
        </div>

        <div className="policy-section">
          <h2>4. Your Rights and Choices</h2>
          <ul>
            <li><strong>Account Access:</strong> Update your information anytime through your dashboard.</li>
            <li><strong>Content Control:</strong> Request removal of your content, subject to platform processing times.</li>
            <li><strong>Data Requests:</strong> Contact us for a copy of your personal data in a portable format.</li>
            <li><strong>Marketing Preferences:</strong> Opt-out of promotional communications while maintaining service notifications.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>5. Data Security</h2>
          <p>We implement robust security measures including:</p>
          <ul>
            <li>End-to-end encryption for all file transfers and sensitive data.</li>
            <li>Secure payment processing with PCI-DSS compliant providers.</li>
            <li>Regular security audits and vulnerability testing.</li>
            <li>Restricted access to personal information on a need-to-know basis.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>6. Content Guidelines and Copyright</h2>
          <p>By using our service, you confirm that:</p>
          <ul>
            <li>You own or have obtained all necessary rights to distribute your content.</li>
            <li>Your content complies with our guidelines (e.g., no unauthorized samples, proper file formats).</li>
            <li>You understand we may review and remove content that violates our terms.</li>
          </ul>
          <p>For copyright claims, please see our <Link to="/copyright">Copyright Policy</Link>.</p>
        </div>

        <div className="policy-section">
          <h2>7. Policy Updates</h2>
          <p>We may update this policy to reflect changes in our services or legal requirements. Significant changes will be communicated through our platform or via email.</p>
        </div>

        <div className="policy-section">
          <h2>8. Contact Information</h2>
          <p>For privacy-related inquiries, please contact:</p>
          <p>
            Data Protection Officer<br />
            <a href="mailto:privacy@falphin.com">privacy@falphin.com</a>
          </p>
          <p>We aim to respond to all inquiries within 48 business hours.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
